import { create } from "zustand";

interface DepartmentPanelState {
  isOpen: boolean;
  isPinned: boolean;
  toggleOpen: () => void;
  togglePin: () => void;
  setOpen: (open: boolean) => void;
  setPinned: (pinned: boolean) => void;
}

export const useDepartmentPanelStore = create<DepartmentPanelState>((set) => ({
  isOpen: false,
  isPinned: false,
  toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
  togglePin: () => set((state) => ({ isPinned: !state.isPinned })),
  setOpen: (open: boolean) => set({ isOpen: open }),
  setPinned: (pinned: boolean) => set({ isPinned: pinned }),
}));
